import React, { Component } from "react";
import axios from "axios";
import apiUrl from "../../../shared/config";
import makeAnimated from "react-select/animated";
import Select from "react-select";

class DeveloperInput extends Component {
    state = {
        developers: [],
        isLoading: true,
        isError: false
    };

    componentDidMount() {
        if (this.props.developersArr && this.props.developersArr.length > 0) {
            this.setState({ developers: this.props.developersArr, isLoading: false });
        } else {
            this.fetchDevelopers();
        }
    }

    fetchDevelopers = () => {
        axios.get(apiUrl + 'Developers/getDevelopers')
            .then(response => {
                this.setState({ developers: response.data, isLoading: false });
            })
            .catch(error => {
                console.error('Error fetching developers:', error);
                this.setState({ isError: true, isLoading: false });
            });
    };

    render() {
        const { developers, isLoading, isError } = this.state;
        const { game_developers_filter, gameDevelopersUpdate, updatePage, closeGameDetails } = this.props;

        // Handle errors
        if (isError) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Error loading developers. Please try again later."
                />
            );
        }

        // Handle loading state
        if (isLoading) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Loading developers..."
                />
            );
        }

        // Handle normal state with data
        const options = developers.map(developer => ({
            value: developer.game_developer_id,
            label: developer.game_developer_name,
            color: '#9999FF'
        }));
        const animatedComponents = makeAnimated();

        const defaultOptions = game_developers_filter.map(developer_id => {
            return options.find(option => option.value === developer_id) || { value: 0, label: "Invalid developer id", color: '#9999FF' };
        });

        return (
            <Select
                isMulti
                isSearchable
                options={options}
                value={defaultOptions}
                closeMenuOnSelect={false}
                components={animatedComponents}
                placeholder="Select developers to search by."
                onChange={(val) => {
                    const retArr = val ? val.map(e => e.value) : [];
                    console.log(retArr);
                    gameDevelopersUpdate(retArr);
                    updatePage(0);
                    closeGameDetails(null);
                }}
            />
        );
    }
}

export default DeveloperInput;